// mock-only: load the committed Claude trace for the case drawer (K6).
// This reads a recorded artifact; it does not start an agent session.

import { useEffect, useState } from 'react';
import { loadFixtureAgentTrace } from '@/shared/contracts/analytics/client';
import type { AgentTrace } from '@/shared/contracts/analytics/v1';

export type AgentTraceState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'ready'; trace: AgentTrace }
  | { status: 'failed' };

/** Load one committed fixture trace; an absent fixture makes no request. */
export function useAgentTrace(fixture: string | undefined): AgentTraceState {
  const [state, setState] = useState<AgentTraceState>(
    fixture ? { status: 'loading' } : { status: 'idle' },
  );

  useEffect(() => {
    if (!fixture) {
      setState({ status: 'idle' });
      return;
    }
    let cancelled = false;
    setState({ status: 'loading' });
    void loadFixtureAgentTrace(fixture)
      .then((trace) => {
        if (!cancelled) setState({ status: 'ready', trace });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'failed' });
      });
    return () => {
      cancelled = true;
    };
  }, [fixture]);

  return state;
}
